/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "onLoad", "onUnload", "onContentLoadStarted"];
import "./Iframe.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useCallback, useEffect } from 'react';
import { useIframeCommunicationChannel } from './useIframeCommunicationChannel';
import { useHostOffsetOverride } from './useHostOffsetOverride';
import { usePerformanceMetrics } from '../performance-metrics';
var iframeStyles = null;
export var Iframe = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var src = _ref.src,
    onLoad = _ref.onLoad,
    onUnload = _ref.onUnload,
    onContentLoadStarted = _ref.onContentLoadStarted,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  var _usePerformanceMetric = usePerformanceMetrics(),
    stopIframeOnloadTimer = _usePerformanceMetric.stopIframeOnloadTimer;
  var iframeOnLoad = useCallback(function (event) {
    stopIframeOnloadTimer();
    onLoad && onLoad(event);
  }, [stopIframeOnloadTimer, onLoad]);
  useEffect(function () {
    var handler = function handler(e) {
      if (e.data.type === 'windowUnload') {
        onUnload === null || onUnload === void 0 || onUnload();
      }
    };
    window.addEventListener('message', handler);
    return function () {
      window.removeEventListener('message', handler);
    };
  }, [onUnload]);
  useHostOffsetOverride();
  var channel = useIframeCommunicationChannel(src, _objectSpread(_objectSpread({}, passThroughProps), {}, {
    onContentLoadStarted: onContentLoadStarted
  }));

  // implementation because cleaner index export is not possible with forwardRef
  return /*#__PURE__*/React.createElement("iframe", _extends({
    ref: ref,
    title: "confluence-article-iframe",
    "data-testid": "confluence-page-iframe",
    name: channel.name,
    src: src,
    onLoad: iframeOnLoad
    // Grant features to iframe (Currently the same as smart card iframe's granted features)
    ,
    allow: "autoplay; fullscreen; encrypted-media; clipboard-write"
    // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
    // Need it in case the browser doesn't support "fullscreen" feature policy.
    ,
    allowFullScreen: true
  }, passThroughProps, {
    className: ax(["_19itglyw _1bsb1osq _4t3i1osq"])
  }));
});